// TopPage.jsx
import React from "react";
import DepotListPage from "./DepotListPage";
import RecentSightings from "./RecentSightings";
import Notices from "./Notices"; // ← 追加

export default function TopPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
        padding: "16px 8px",
      }}
    >
      <header
        style={{
          textAlign: "center",
          marginBottom: "32px",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            borderRadius: "999px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(4,120,87,0.25)",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              background: "#2C9736",
              padding: "10px 14px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="/logo512.png"
              alt="BusWatch logo"
              style={{ width: 48, height: 48, display: "block", borderRadius: "50%" }}
            />
          </div>
          <div
            style={{
              background: "#d1fae5",
              padding: "10px 22px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontSize: "26px",
                fontWeight: "800",
                color: "#047857",
                letterSpacing: "0.5px",
                whiteSpace: "nowrap",
              }}
            >
              西鉄バスWatch!
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginTop: "6px",
          }}
        >
          <span style={{ width: 28, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
          <p
            style={{
              color: "#065f46",
              fontWeight: "500",
              fontSize: "13px",
              letterSpacing: "0.08em",
              margin: 0,
            }}
          >
            西鉄バス目撃情報共有コミュニティサイト
          </p>
          <span style={{ width: 28, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
        </div>
      </header>

      {/* お知らせ */}
      <section
        style={{
          backgroundColor: "#a7f3d0",
          borderRadius: "12px",
          padding: "0px 12px 12px 12px",
          marginBottom: "32px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <Notices />
      </section>

      {/* 新着投稿埋込み */}
      <section
        style={{
          backgroundColor: "#a7f3d0",
          borderRadius: "12px",
          padding: "0px 12px 12px 12px",
          marginBottom: "32px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <RecentSightings />
      </section>

      {/* 運用ルール */}
      <section
        style={{
          backgroundColor: "#FF7F7F",
          borderRadius: "12px",
          padding: "12px",
          marginBottom: "32px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          fontWeight: "600",
        }}
      >
        投稿ルールは必ずご一読ください。
        <a
          href="/rule"
            style={{
              display: "inline-block",
              backgroundColor: "#fff",
              color: "#FF5C5C",
              padding: "6px 12px",
              borderRadius: "8px",
              textDecoration: "none",
              transition: "all 0.2s ease",
              margin: "4px 4px 4px 0px",
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = "#ffe5e5"}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
          >
            投稿ルールページへ
        </a>
      </section>

      {/* 営業所一覧 */}
      <section>
        <DepotListPage showTitle={false} />
      </section>

      {/* アーカイブ */}
      <section
        style={{
          backgroundColor: "#a7f3d0",
          borderRadius: "12px",
          padding: "12px",
          marginBottom: "24px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          fontWeight: "600",
        }}
      >
        過去データを参照されたい方はアーカイブページへ。
        <a
          href="/archive"
            style={{
              display: "inline-block",
              backgroundColor: "#fff",
              color: "#047857",
              padding: "6px 12px",
              borderRadius: "8px",
              textDecoration: "none",
              transition: "all 0.2s ease",
              margin: "4px 4px 4px 0px",
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = "#e5ffe5"}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
          >
            アーカイブページへ
        </a>
      </section>

      {/* 情報提供BBS */}
      <section
        style={{
          backgroundColor: "#a7f3d0",
          borderRadius: "12px",
          padding: "12px",
          marginBottom: "24px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          fontWeight: "600",
        }}
      >
        車両転属・廃車情報、要望などありましたら情報提供BBSへ。
        <a
          href="/bbs"
            style={{
              display: "inline-block",
              backgroundColor: "#fff",
              color: "#047857",
              padding: "6px 12px",
              borderRadius: "8px",
              textDecoration: "none",
              transition: "all 0.2s ease",
              margin: "4px 4px 4px 0px",
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = "#e5ffe5"}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
          >
            情報提供BBSページへ
        </a>
      </section>

      {/* プライバシーポリシー */}
      <section
        style={{
          backgroundColor: "#a7f3d0",
          borderRadius: "12px",
          padding: "12px",
          marginBottom: "32px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          fontWeight: "600",
        }}
      >
        当サイトのプライバシーポリシーについてはこちら。
        <a
          href="/privacy"
            style={{
              display: "inline-block",
              backgroundColor: "#fff",
              color: "#047857",
              padding: "6px 12px",
              borderRadius: "8px",
              textDecoration: "none",
              transition: "all 0.2s ease",
              margin: "4px 4px 4px 0px",
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = "#e5ffe5"}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
          >
            プライバシーポリシーページへ
        </a>
      </section>
    </div>
  );
}
